import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

export const GenericSelector = ({
  displayEmpty = false,
  getOptionId = option => option.id,
  getOptionLabel = option => option.label || option.value,
  onChange,
  options,
  size = 'small',
  value
}) => {
  return (
    <FormControl size={size}>
      <Select
        value={value || ''}
        onChange={e => onChange(e.target.value)}
        variant="outlined"
        displayEmpty={displayEmpty}
      >
        {options.map(option => (
          <MenuItem key={getOptionId(option)} value={getOptionId(option)}>
            {getOptionLabel(option)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
